export default __webpack_public_path__ + "static/media/Dolls.b6e3f989.png";